import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { ArrowUp } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const SHOW_AFTER_PX = 400;

/** Floating scroll-to-top button. Mirrors side by language (bottom-right in
 * LTR stacked above WhatsAppButton, bottom-left in RTL where nothing else
 * sits) so it never overlaps the WhatsApp button. Brand cyan/navy only. */
export const BackToTop = () => {
  const { lang } = useLang();
  const isRtl = lang === "ar";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          onClick={scrollToTop}
          data-testid="back-to-top-button"
          aria-label={lang === "en" ? "Back to top" : "العودة لأعلى الصفحة"}
          className={`group fixed z-40 w-12 h-12 rounded-full border border-soft bg-app-elev/80 backdrop-blur-xl flex items-center justify-center shadow-lg transition-colors hover:border-cyan-400/60 hover:shadow-[0_0_28px_rgba(0,229,255,0.35)] ${
            isRtl ? "bottom-6 left-6" : "bottom-24 right-6"
          }`}
          initial={{ opacity: 0, scale: 0.7 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.7 }}
          transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
        >
          <ArrowUp className="w-5 h-5 text-cyan-300 group-hover:text-cyan-200 transition-colors" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
